<template>
  <div class="red_packet">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="content">
        <div class="flex" v-for="item in list" :key="item.id">
          <p>
            <span class="symbol">¥</span>
            <span class="price">{{item.price}}</span>
          </p>
          <div class="go_select">
            <p>已领取</p>
            <p>{{item.received_number}}/{{item.number}}</p>
          </div>
          <div class="btn">
            <span class="goShare" @click="goShare(item)">去分享</span>
            <span class="detail" @click="jump(item)">详情</span>
          </div>
        </div>
      </div>
    </van-list>
    <!-- 分享提示 -->
    <van-overlay :show="isTips" @click="isTips = false">
      <div class="wrapper_m" @click.stop>
        <img :src="imgPath + 'yj_share.png'" alt />
        <img @click="isTips = false" class="n_shareBtn" :src="imgPath + 'byj_utton.png'" alt />
      </div>
    </van-overlay>
    <div class="content_container">
      <vue-canvas-poster :widthPixels="1000" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
      <van-overlay :show="isPoster" @click="isPoster = false">
        <div class="wrapper_n" @click.stop>
          <div class="share-img">
            <img class="n_canvas" :src="posterImg" alt="分享图片" />
            <p class="n_save">长按保存到本地</p>
          </div>
        </div>
      </van-overlay>
    </div>
    <van-share-sheet v-model="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
  </div>
</template>

<script>
import share from '../../public/share.js'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      finished: false,
      loading: false,
      page: 0,
      list: [],
      painting: {},
      posterImg: '', //生成的海报
      isTips: false,
      showShare: false,
      options: [
        { name: '微信', icon: 'wechat' },
        { name: '分享海报', icon: 'poster' },
      ],
      isPoster: false,
      userInfo: {},
    }
  },
  mounted() {
    this.getUrl()
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  created() {
    if (this.$store.state.shareStr != 'redList') {
      new share(
        {
          startUrl: window.location.href,
        },
        this.$store,
        'homeIndex'
      )
    } else {
      this.shareModelFg()
    }
  },
  watch: {
    '$store.state.shareStr': function (e) {
      if (e == 'redList') {
        this.shareModelFg()
      }
    },
  },
  methods: {
    //去分享
    goShare(e) {
      this.showShare = true
      this.getMemberRedPacketPoster(e.id)
    },
    onSelect(option) {
      if (option.icon == 'wechat') {
        this.isTips = true
        this.showShare = false
      } else {
        this.isPoster = true
        this.showShare = false
      }
    },
    jump(e) {
      this.$router.push({ path: 'redDetails', query: { id: e.id } })
    },
    //成功生成海报
    success(src) {
      this.posterImg = src
      // console.log(src)
    },
    fail(err) {
      console.log(err)
    },
    onLoad() {
      this.page++
      this.getMemberRedPacketList()
    },
    getMemberRedPacketList() {
      this.http('MemberRedPacket.getMerchantRedPacketList', {
        page: this.page,
        limit: 20,
      }).then((e) => {
        this.list = [...this.list, ...e.content.list]
        this.finished = this.list.length == e.content.count
        console.log(e)
      })
    },
    //海报分享
    poriteFg(e) {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      this.painting = {
        width: '610px',
        height: '790px',
        borderRadius: '40px',
        background:
          'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yijiu_hbfm.png',
        views: [
          {
            type: 'image',
            url: e.share_avatar,
            css: {
              left: '255px',
              top: '34px',
              borderRadius: '50%',
              width: '100px',
              height: '100px',
            },
          },
          {
            type: 'text',
            text: e.share_name,
            css: {
              left: '257px',
              top: '142px',
              width: '360px',
              maxLines: 1,
              fontSize: '26px',
              color: 'rgba(251, 220, 159, 1)',
            },
          },
          {
            type: 'text',
            text: `发了${e.price_dollar}现金红包`,
            css: {
              top: '201px',
              left: '138px',
              width: '340px',
              maxLines: 1,
              fontSize: '32px',
              lineHeight: '30px',
              color: 'rgba(251, 220, 159, 1)',
              textAlign: 'center',
            },
          },
          {
            type: 'text',
            text: '数量有限，快来抢吧',
            css: {
              top: '254px',
              left: '161px',
              width: '340px',
              maxLines: 1,
              fontSize: '32px',
              lineHeight: '30px',
              color: 'rgba(251, 220, 159, 1)',
            },
          },
          {
            type: 'text',
            text: '微信扫一扫或长按抢红包',
            css: {
              bottom: '50px',
              left: '140px',
              width: '360px',
              maxLines: 1,
              fontSize: '30px',
              lineHeight: '30px',
              color: 'rgba(255, 255, 255, 1)',
            },
          },
          {
            type: 'qrcode',
            content: e.share_url,
            css: {
              bottom: '116px',
              left: '226px',
              color: '#000',
              width: '151px',
              height: '151px',
              borderWidth: '10px',
              borderColor: '#fff',
              borderRadius: '50%',
              background: '#fff',
            },
          },
        ],
      }
    },
    //分享信息
    getMemberRedPacketPoster(id) {
      this.http('MemberRedPacket.getMemberRedPacketPoster', {
        packet_id: id,
      }).then((e) => {
        this.poriteFg(e.content)
        this.shareModelFg(e.content)
      })
    },
    shareModelFg(e) {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })
      let shareInfo = {
        title: e.share_title,
        desc: e.share_desc,
        link: e.share_url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
        imgUrl: e.share_logo,
      }
      wx.onMenuShareAppMessage(shareInfo)
      wx.onMenuShareTimeline(shareInfo)
    },
  },
}
</script>

<style scoped lang="scss">
.red_packet {
  background: #f7f8fa;
  .content {
    padding: 20px;
    .flex {
      align-items: center;
      justify-content: space-between;
      background: rgba(255, 255, 255, 1);
      padding: 43px 30px;
      border-radius: 20px;
      margin-bottom: 20px;
      .symbol {
        font-size: 22px;
        font-weight: 800;
        color: #fe161c;
      }
      .price {
        font-size: 48px;
        font-weight: 800;
        color: #fe161c;
      }
      .go_select {
        font-size: 22px;
        color: #999999;
      }
      .btn {
        .goShare {
          padding: 10px 28px;
          font-size: 28px;
          color: #ffffff;
          background: #ee0a24;
          border-radius: 31px;
          margin-right: 10px;
        }
        .detail {
          padding: 10px 42px;
          font-size: 28px;
          color: #ee0a24;
          background: #ffe7ea;
          border-radius: 31px;
        }
      }
    }
  }
}
.wrapper_m img {
  width: 95%;
}
.n_shareBtn {
  display: block;
  width: 236px !important;
  margin: 400px auto 0;
}
.wrapper_n {
  width: 596px;
  height: 800px;
  margin: 200px auto 0;
}
.n_canvas {
  // width: 596px;
  height: 800px;
}
.n_save {
  font-size: 36px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-top: 20px;
}
</style>